// pages/WebTabsPage.js
import React, { useRef, useState } from "react";
import "../styles/WebTabsPage.css";

const tabs = [
  {
    key: "site1",
    label: "買取管理",
    url: "https://www.pasomaru.co.jp/control-panel-8f3k2x/dashboard",
    partition: "persist:pasomaru-control",
  },
  {
    key: "site2",
    label: "メール",
    url: "https://roundcube.red.shared-server.net/",
    partition: "persist:roundcube-account-1",
    loginKey: "roundcube-main",
  },
  {
    key: "site3",
    label: "メール確認用",
    url: "https://roundcube.red.shared-server.net/",
    partition: "persist:roundcube-account-2",
    loginKey: "roundcube-check",
  },
];

export default function WebTabsPage() {
  const [active, setActive] = useState(tabs[0].key);
  const webviewRefs = useRef({});

  const getActiveView = () => webviewRefs.current[active];

  const goBack = () => {
    const view = getActiveView();
    if (view?.canGoBack()) view.goBack();
  };

  const goForward = () => {
    const view = getActiveView();
    if (view?.canGoForward()) view.goForward();
  };

  const reload = () => {
    getActiveView()?.reload();
  };

  const setupWebview = (el, tab) => {
    if (!el) return;

    webviewRefs.current[tab.key] = el;

    if (el.dataset.ready === "1") return;
    el.dataset.ready = "1";

    el.addEventListener("dom-ready", async () => {
        if (!tab.loginKey) return;
        if (!window.electronAPI?.getWebLogin) return;

        const login = await window.electronAPI.getWebLogin(tab.loginKey);

        if (!login?.username || !login?.password) return;

        const username = JSON.stringify(login.username);
        const password = JSON.stringify(login.password);

        el.executeJavaScript(`
        (() => {
            const user =
            document.querySelector('input[name="_user"]') ||
            document.querySelector('input[name="username"]') ||
            document.querySelector('input[type="email"]') ||
            document.querySelector('input[type="text"]');

            const pass =
            document.querySelector('input[name="_pass"]') ||
            document.querySelector('input[name="password"]') ||
            document.querySelector('input[type="password"]');

            if (user && !user.value) {
            user.focus();
            user.value = ${username};
            user.dispatchEvent(new Event("input", { bubbles: true }));
            user.dispatchEvent(new Event("change", { bubbles: true }));
            }

            if (pass && !pass.value) {
            pass.focus();
            pass.value = ${password};
            pass.dispatchEvent(new Event("input", { bubbles: true }));
            pass.dispatchEvent(new Event("change", { bubbles: true }));
            }

            // 自動ログインまで実行
            if (user?.value && pass?.value) {
            const btn =
                document.querySelector('button[type="submit"]') ||
                document.querySelector('input[type="submit"]') ||
                document.querySelector('#rcmloginsubmit');

            if (btn) {
                btn.click();
            } else {
                const form = user.closest("form") || pass.closest("form");
                if (form) form.submit();
            }
            }
        })();
        `);
    });
    };

  return (
    <div className="webTabsPage">
      <div className="webTabsPage__toolbar">
        <button onClick={goBack}>戻る</button>
        <button onClick={goForward}>進む</button>
        <button onClick={reload}>更新</button>

        <div className="webTabsPage__tabs">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              className={active === tab.key ? "active" : ""}
              onClick={() => setActive(tab.key)}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      <div className="webTabsPage__body">
        {tabs.map((tab) => (
          <webview
            key={tab.key}
            ref={(el) => setupWebview(el, tab)}
            src={tab.url}
            partition={tab.partition}
            allowpopups="true"
            className={
              active === tab.key
                ? "webTabsPage__webview active"
                : "webTabsPage__webview"
            }
          />
        ))}
      </div>
    </div>
  );
}